import axios from "axios";
const serviceSearch = document.querySelector(".service-search");
const servicesFoundContainer = document.querySelector("#service-found");
const doctorCardTemplate = document.querySelector("[data-doctor-template]");
const pricesContainer = document.querySelector(".prices__list");
const departmentsLinks = document.querySelectorAll(".prices__group");
const priceCardTemplate = document.querySelector("[data-price-template]");
const priceSpeTemplate = document.querySelector(
    "[data-price-specialty-template]"
);
const priceServiceTemplate = document.querySelector(
    "[data-price-service-template]"
);
let services = [];

let adultServices = [];

// отображение цен

const getServices = () => {
    axios
        .get("/api/services?clinic=" + sessionStorage.getItem('clinic'))
        .then((response) => {
            services = response.data.data;
            renderServices(services, "Взрослое отделение");
        })

};
getServices();
const renderServices = (array, dpt) => {
    adultServices = array.filter((el) => el.department === dpt);
    const serviceDepCard =
        priceCardTemplate.content.cloneNode(true).children[0];
    const serviceDepHeader = serviceDepCard.querySelector(
        "[data-price-header]"
    );
    serviceDepHeader.textContent = adultServices[0].department;
    const priceContainer = serviceDepCard.querySelector(
        ".prices__specialities-list"
    );
    pricesContainer.append(serviceDepCard);

    const specialtiesSet = new Set();

    adultServices.forEach((dep) => {
        specialtiesSet.add(dep.specialty);
    });

    specialtiesSet.forEach((specialty) => {
        const servicesInSpecialty = adultServices.filter(
            (dep) => dep.specialty === specialty
        );
        const serviceSpeCard =
            priceSpeTemplate.content.cloneNode(true).children[0];
        const serviceSpeHeader = serviceSpeCard.querySelector(
            "[data-price-speciality-header]"
        );
        serviceSpeHeader.textContent = specialty;
        const servicesContainer = serviceSpeCard.querySelector(
            ".prices__services-list"
        );

        servicesInSpecialty.forEach((service) => {
            const serviceCard =
                priceServiceTemplate.content.cloneNode(true).children[0];
            const serviceHeader = serviceCard.querySelector(
                "[data-price-service-header]"
            );
            serviceHeader.textContent = service.name;
            const servicePrice = serviceCard.querySelector(
                "[data-price-service-value]"
            );
            const serviceCode = serviceCard.querySelector(
                "[data-price-service-code]"
            );

            if (service.nomenclature_code) {
                serviceCode.textContent = `(${service.nomenclature_code})`;
            } else {
                serviceCode.remove();
            }

            servicePrice.textContent = service.price;
            servicesContainer.append(serviceCard);
        });

        serviceSpeCard.addEventListener("click", () => {
            servicesContainer.classList.toggle("prices__services-list_open");
        });

        priceContainer.append(serviceSpeCard);
    });
};

departmentsLinks.forEach((link) => {
    link.addEventListener("click", () => {
        pricesContainer.innerHTML = "";
        const id = link.getAttribute("id");
        switch (id) {
            case "adults":
                renderServices(services, "Взрослое отделение");
                break;
            case "children":
                renderServices(services, "Детское отделение");
                break;
            case "laboratory":
                renderServices(services, "Лаборатория");
                break;
            case "dentistry":
                renderServices(services, "Стоматология");
                break;
            default:
                renderServices(services, "Взрослое отделение");
        }
    });
});

let servicesList = [];

serviceSearch.addEventListener("input", (evt) => {
    const value = evt.target.value.toLowerCase();
    servicesList.forEach((doc) => {
        const isVisible =
            doc.name.toLowerCase().includes(value) ||
            doc.specialty.toLowerCase().includes(value);
        doc.element.classList.toggle("hide", !isVisible);
        if (value == "") {
            doc.element.classList.add("hide");
        }
    });
});

axios
    .get("/api/services?search&clinic=" + sessionStorage.getItem('current_clinic'))
    .then((response) => {
        console.log(sessionStorage.getItem('current_clinic'))
        const res = response.data.data;
        servicesList = res.map((doc) => {
            const card = doctorCardTemplate.content.cloneNode(true).children[0];
            const header = card.querySelector("[data-header]");
            const job = card.querySelector("[data-job]");
            const price = card.querySelector("[data-price]");
            const nomenclatureCode = card.querySelector("[data-nomenclature-code]");
            price.textContent = doc.price;
            header.textContent = doc.name;
            if (doc.nomenclature_code) {
                nomenclatureCode.textContent = `(${doc.nomenclature_code})`;
            } else {
                nomenclatureCode.remove();
            }
            job.textContent = doc.specialty;
            servicesFoundContainer.append(card);
            card.classList.add("hide");
            return {
                name: doc.name,
                specialty: doc.specialty,
                price: doc.price,
                department: doc.department,
                element: card,
            };
        });
    })
    .catch((error) => console.log(error));
